<template>
  <div class="panel-footer">
    <div>
      <select class="btn btn-default btn-sm" v-model="qtd">
        <option value="5">05</option>
        <option value="10">10</option>
        <option value="15">15</option>
        <option value="25">25</option>
        <option value="50">50</option>
      </select>
      <small> Exibindo {{pagination.from}} - {{pagination.to}} de {{pagination.total}} resultados.</small>
    </div>
    <div>
      <button type="button" class="btn btn-sm" :disabled="pagination.current_page <= 1" @click="changePage(pagination.current_page - 1)">&laquo;
        Anterior</button>
      <button type="button" class="btn btn-sm" :disabled="pagination.current_page >= pagination.last_page" @click="changePage(pagination.current_page + 1)">Próximo
        &raquo;</button>
    </div>
  </div>

</template>
<script>
  export default {
   props: {
    amount: Number,
    pagination: Object,
    },
    methods: {
      isCurrentPage(page) {
        return this.pagination.current_page === page;
      },
      changePage(page) {
        if (page > this.pagination.last_page) {
          page = this.pagination.last_page;
        }
        this.$emit('paginate', {
          'amount': this.amount,
          'page': page
        });
      },
      getData() {
        this.$emit('paginate', {
          'amount': this.amount,
          'page': 1
        });
      }
    },
    computed: {
      qtd: {
        get: function() {
          return this.amount;
        },
        set: function(newValue) {
        this.$emit('paginate', {
          'amount': newValue,
          'page': 1
        });
        }
      },
      pages() {
        let pages = [];
        let from = this.pagination.current_page - Math.floor(this.offset / 2);
        if (from < 1) {
          from = 1;
        }
        let to = from + this.offset - 1;
        if (to > this.pagination.last_page) {
          to = this.pagination.last_page;
        }
        while (from <= to) {
          pages.push(from);
          from++;
        }
        return pages;
      }
    }
  };
</script>